/* es-cart-savings-fix.js (4 Nov 2026, approved by Wanda 12:41pm AEDT).
   Section Store cart drawer: its "Discount" row adds compare-at savings to real discounts (Pink Bundle $665 -> $565 showed "Discount -$100"
   with no discount applied). The app has no theme setting for this (config lives in the app). This keeps the row only for REAL discounts:
   amount = /cart.js total_discount (code or automatic discounts). If total_discount is 0 the row is hidden. The struck compare-at subtotal is removed.
   Line item compare-at prices are left as they are. Rollback: cro/bf26_discount_setup_2026-11-04/discount100/fix/rollback_fix.py */
(function(){
  var fmt = function(c){ return '$' + (c / 100).toFixed(2); };
  var busy = false, t;
  function roots(){ var a = []; document.querySelectorAll('section-store--cart-block').forEach(function(e){ if (e.shadowRoot) { if (!e.shadowRoot.__esfix) { e.shadowRoot.__esfix = 1; try { new MutationObserver(run).observe(e.shadowRoot, {childList: true, subtree: true, characterData: true}); } catch (x) {} } a.push(e.shadowRoot); } }); return a; }
  function apply(){
    var rs = roots(); if (!rs.length) return;
    rs.forEach(function(r){ r.querySelectorAll('.cart-subtotal-compare').forEach(function(c){ c.remove(); }); });
    var need = rs.some(function(r){ var d = r.querySelector('.cart-discount-total'); return d && !d.hidden && d.getAttribute('data-esfix') !== d.innerText; });
    if (!need || busy) return;
    busy = true;
    fetch('/cart.js', {credentials: 'same-origin'}).then(function(x){ return x.json(); }).then(function(c){
      var real = c.total_discount || 0;
      rs.forEach(function(r){
        var d = r.querySelector('.cart-discount-total'); if (!d || d.hidden) return;
        if (real <= 0) { d.hidden = true; d.style.display = 'none'; return; }
        d.style.display = '';
        var sp = d.querySelectorAll('.cart-discount-total-row span'); if (sp.length > 1 && sp[1].textContent !== '-' + fmt(real)) sp[1].textContent = '-' + fmt(real);
        d.setAttribute('data-esfix', d.innerText);
      });
    }).catch(function(){}).then(function(){ busy = false; });
  }
  function run(){ clearTimeout(t); t = setTimeout(apply, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  try { new MutationObserver(run).observe(document.documentElement, {childList: true, subtree: true}); } catch (x) {}
})();

/* BF26 discount-code box hide (approved by Wanda 4 Nov 2026 12:52pm AEDT). Hidden ONLY from 2026-11-08T05:59:00Z (Sun 8 Nov 16:59 AEDT)
   until 2026-11-15T13:00:00Z (Mon 16 Nov 00:00 AEDT), in the Section Store drawer (.cart-discount-code) and the cart page coupon (li.cart-total-coupon).
   Clock: server Liquid 'now' (data-srvnow on the script tag) + time since page load; falls back to the browser clock if absent.
   Preview theme only: ?bfnow=<ISO date> (kept in sessionStorage esbfnow; ?bfnow=off clears) simulates the date. Rollback: bf_window/theme/rollback_theme.py */
(function(){
  var A = Date.parse('2026-11-08T05:59:00Z'), B = Date.parse('2026-11-15T13:00:00Z');
  var me = document.currentScript || document.querySelector('script[data-srvnow]');
  var srv = me && parseInt(me.getAttribute('data-srvnow'), 10);
  var t0 = Date.now(), base = srv ? srv * 1000 : t0;
  var sim = null;
  try {
    var th = window.Shopify && Shopify.theme;
    if (th && th.role !== 'main' && String(th.id) === '192285409592') {
      var q = new URLSearchParams(location.search).get('bfnow');
      if (q === 'off') sessionStorage.removeItem('esbfnow'); else if (q && !isNaN(Date.parse(q))) sessionStorage.setItem('esbfnow', q);
      var s = sessionStorage.getItem('esbfnow'); if (s && !isNaN(Date.parse(s))) sim = Date.parse(s);
    }
  } catch (x) {}
  function now(){ return sim !== null ? sim : base + (Date.now() - t0); }
  function on(){ var n = now(); return n >= A && n < B; }
  var css = '.cart-discount-code{display:none!important}';
  function apply(){
    var h = on();
    document.documentElement.classList.toggle('es-bf-nocode', h);
    var st = document.getElementById('es-bf-nocode-css');
    if (h && !st) { st = document.createElement('style'); st.id = 'es-bf-nocode-css'; st.textContent = 'li.cart-total-coupon,.cart-total-coupon{display:none!important}'; document.head.appendChild(st); }
    if (!h && st) st.remove();
    document.querySelectorAll('section-store--cart-block').forEach(function(e){
      var r = e.shadowRoot; if (!r) return; var s = r.getElementById('es-bf-nocode-css');
      if (h && !s) { s = document.createElement('style'); s.id = 'es-bf-nocode-css'; s.textContent = css; r.appendChild(s); }
      if (!h && s) s.remove();
    });
  }
  var t; function run(){ clearTimeout(t); t = setTimeout(apply, 30); }
  apply(); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  try { new MutationObserver(run).observe(document.documentElement, {childList: true, subtree: true}); } catch (x) {}
  setInterval(apply, 30000);
})();
